import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import Select from 'react-select'
import { currentDateAndTime, decodeData } from '../../Constants/constants';

class OverTime extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            company_overtime_id: 0,
            overtime_type_name: '',
            overtime_head_ids: '',
            overtime_multiplication_hrs: '',
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            salary_heads_rows: [],
            loadingList: false,
            postLoading: false,
            errors: {},
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetSalaryHeadsList();
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    GetInfo = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetOverTimeInfo?company_overtime_id=${this.state.company_overtime_id}`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        overtime_type_name: data[0].overtime_type_name,
                        overtime_head_ids: data[0].overtime_head_ids,
                        overtime_multiplication_hrs: data[0].overtime_multiplication_hrs,
                        errors: {}
                    }
                )
            }
        });
    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetOverTimes`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }
    GetSalaryHeadsList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetSalaryHeads`, { params: { limit: 1000, page: this.state.page }, headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        salary_heads_rows: data.data.map((row) => ({
                            value: row.company_salary_head_id,
                            label: row.company_salary_head
                        }))
                    }));
                }
            });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {
            overtime_type_name: this.state.overtime_type_name,
            overtime_head_ids: this.state.overtime_head_ids,
            overtime_multiplication_hrs: this.state.overtime_multiplication_hrs,
            date: currentDateAndTime()
        }

        if (this.state.company_overtime_id !== 0) {
            formData.company_overtime_id = this.state.company_overtime_id;
        }

        axios.post(`${apiURL}Masters/CreateOverTime`, formData, { headers }).then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.resetForm();
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    timer: 2000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
            }

        })
    };
    resetForm = () => {
        this.setState({
            company_overtime_id: 0,
            overtime_type_name: '',
            overtime_head_ids: '',
            overtime_multiplication_hrs: ''
        })

    }

    validateForm() {
        const errors = {};

        if (!this.state.overtime_type_name) {
            errors.overtime_type_name = 'Over time title is required';
        }
        if (!this.state.overtime_multiplication_hrs) {
            errors.overtime_multiplication_hrs = 'Over time multiplication hours are required';
        }
        if (!this.state.overtime_head_ids) {
            errors.overtime_head_ids = 'At least one salary head must be selected';
        }

        return errors;
    }


    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true });
                const formData = {
                    company_overtime_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteOverTime`, formData, { headers })
                    .then((response) => {

                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {

                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    handleSelect = (e) => {

        var ids = [];
        for (var i = 0; i < e.length; i++) {
            ids.push(e[i].value);
        }
        this.setState({
            overtime_head_ids: ids.join(','),
            errors: {
                ...this.state.errors,
                overtime_head_ids: '',
            }
        });
    }

    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Over Time Master`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">Over Time Master</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-12">
                                                        <label>OT Component Salary Head's</label>
                                                        <Select
                                                            onChange={this.handleSelect}
                                                            placeholder={`Select Salary Head's`}
                                                            isMulti
                                                            value={this.state.overtime_head_ids.split(',').map(id => this.state.salary_heads_rows.find(option => option.value === parseInt(id)))}
                                                            isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            options={this.state.salary_heads_rows} />
                                                        {errors.overtime_head_ids && <div className="text-danger">{errors.overtime_head_ids}</div>}
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="overtime_type_name" className="form-label">Over time title</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.overtime_type_name ? 'is-invalid' : ''}`}
                                                            id="overtime_type_name"
                                                            name="overtime_type_name"
                                                            value={this.state.overtime_type_name}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter over time title"
                                                        />
                                                        {errors.overtime_type_name && <div className="text-danger">{errors.overtime_type_name}</div>}
                                                    </div>
                                                    {/* <div className="col-md-6 mt-3">
                                                        <TextBox type='number' id='' name='' value={this.state.dsf} label='OT Month Days' hint='Enter OT Month' change={this.handleInputChange} />
                                                    </div> */}
                                                    <div className="col-md-6 mt-3">
                                                        <label htmlFor="overtime_multiplication_hrs" className="form-label">Over time title</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.overtime_multiplication_hrs ? 'is-invalid' : ''}`}
                                                            id="overtime_multiplication_hrs"
                                                            name="overtime_multiplication_hrs"
                                                            value={this.state.overtime_multiplication_hrs}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            onChange={this.handleInputChange}
                                                            placeholder="Enter over time title"
                                                        />
                                                        {errors.overtime_multiplication_hrs && <div className="text-danger">{errors.overtime_multiplication_hrs}</div>}
                                                    </div>

                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.company_overtime_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.company_overtime_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.company_overtime_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)

                                                        }

                                                        {
                                                            this.state.company_overtime_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-light right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-arrow-right-line label-icon align-middle fs-16 ms-2`} />{" "}New</button> : <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th width={150}>OT Title</th>
                                                    <th>OT Salary Head's</th>
                                                    {/* <th>OT Month Days</th> */}
                                                    <th >OT Multiplication Hours</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th className='text-center' width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.company_overtime_id}>
                                                            <td>{row.overtime_type_name}</td>
                                                            <td>{row.heads_labels[0].concatenated_data}</td>
                                                            {/* <td></td> */}
                                                            <td>{row.overtime_multiplication_hrs}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                    <button type='button' onClick={() => this.setState({ company_overtime_id: row.company_overtime_id }, (prevState) => this.GetInfo())} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                    <button onClick={() => this.handleDelete(row.company_overtime_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }

                                            </tbody>
                                            <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>

                                            </tfoot>

                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(OverTime);



